import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import { ErrorDialogComponent } from './error.dialog/error.dialog.component';
import { ResponseErrorDialogComponent } from './response-error.dialog/response-error.dialog.component';
import { Subject, takeUntil } from 'rxjs';
import { ApiError, ApplicationError } from '../../core/error';
import { ExceptionService } from '../../core/exception.service';
import { SessionData } from '../../core/session-data';
import { SpinService } from '../../core/spin.service';

@Component({
  standalone: false,
  selector: 'app-error',
  templateUrl: './error.component.html'
})

export class ErrorComponent implements OnInit, OnDestroy {
  private fallbackUrl: string;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private exceptionService: ExceptionService,
    private spinService: SpinService,
    @Inject(DOCUMENT) private document: Document,
    public dialog: MatDialog,
    private sessionData: SessionData
  ) { }

  ngOnInit() {

    this.exceptionService.apiErrors
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((error) => this.apiErrorHandler(error));

    this.exceptionService.appErrors
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((error) => this.appErrorHandler(error));

    this.exceptionService.responseErrors
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((error) => this.responseErrorHandler(error));

    this.fallbackUrl = this.sessionData.fallbackUrl;
  }


  ngOnDestroy(): void {
    this.ngUnsubscribe?.next();
    this.ngUnsubscribe?.complete();
  }

  private apiErrorHandler(error: ApiError): void {
    try {

      this.showErrorDialog(error);

    } catch (exception) {
      console.error(exception);
    }
  }

  private appErrorHandler(error: ApplicationError): void {
    try {

      this.showErrorDialog(error);

    } catch (exception) {
      console.error(exception);
    }
  }

  // TODO: should be HttpErrorResponse instead any after moving on HttpClient
  private responseErrorHandler(error: any): void {
    try {

      this.showResponseErrorDialog(error);

    } catch (exception) {
      console.error('open dialog exception:', exception);
    }
  }

  // TODO: should be HttpErrorResponse instead any after moving on HttpClient
  private showResponseErrorDialog(error: any): void {
    try {

      // stop spin before show error
      this.spinService.stop();

      if (this.getErrorDialogs().length > 0) {
        return;
      }

      const diag = this.dialog.open(ResponseErrorDialogComponent, {
        backdropClass: 'custom-overlay-pane-class',
        width: '500px',
        data: {
          error: error
        }
      });

      diag.afterClosed()
        .subscribe(result => {
          if (!result) {
            return;
          }

          this.document.location.href = this.fallbackUrl
            ? this.fallbackUrl
            : '/';
        });

    } catch (exception) {
      console.error(exception);
    }
  }

  private showErrorDialog(error: any): void {
    try {

      // stop spin before show error
      this.spinService.stop();

      if (this.getErrorDialogs().length > 0) {
        return;
      }

      const diag = this.dialog.open(ErrorDialogComponent, {
        // position: { top: `${top}px`, left: `${left}px` },
        backdropClass: 'custom-overlay-pane-class',
        data: {
          error: error
        }
      });

      diag.afterClosed()
        .subscribe(result => {
          if (!result) {
            return;
          }
        });

    } catch (exception) {
      console.error(exception);
    }
  }

  private getErrorDialogs() {
    return this.dialog.openDialogs.filter(x => {
      return x.componentInstance.isErrorDialog;
    });
  }
}
